import { useState } from "react";
import Icons from "../../../../components/icons/index";
import { Link } from "react-router-dom";

const AuthForm = ({
    formInputs,
    onChange,
    formType = "signup",
    handleSubmit,
    error,
    loader,
    handleForgetPassword,
}) => {
    const [fieldType, setFieldType] = useState("password");
    const toggleFieldType = () => {
        setFieldType((prev) => (prev === "password" ? "text" : "password"));
    };

    return (
        <div className="w-full">
            <input
                type="email"
                required
                placeholder="name@example.com"
                value={formInputs.email}
                onChange={onChange}
                name="email"
            />
            <div className="relative mt-2.5">
                <input
                    type={fieldType}
                    placeholder="password"
                    value={formInputs.password}
                    onChange={onChange}
                    name="password"
                />
                {formInputs.password && (
                    <span
                        className="absolute top-1/2 -translate-y-1/2 right-4 cursor-pointer"
                        onClick={toggleFieldType}
                    >
                        <Icons id={fieldType === "password" ? "eyeIcon" : "eyeCrossIcon"} />
                    </span>
                )}
            </div>
            {formType !== "signup" && (
                <p className="px-2.5 pt-3 text-[#757575] text-xs text-left">
                    <Link to={""} onClick={handleForgetPassword && handleForgetPassword}>
                        Forgot password?
                    </Link>
                </p>
            )}
            {error && (
                <p className="text-red-500 pt-2">
                    {error.toLowerCase().includes("invalid email or password")
                        ? "Email and password didn’t match. Forgot your password? Reset it."
                        : error.toLowerCase().includes("user not found!!")
                            ? "There is no account associated with that email address. Please sign up."
                            : error}
                </p>
            )}
            <button
                className={`w-full mt-11 text-center py-4 rounded font-medium ${formInputs.email === "" && formInputs.password === ""
                    ? "bg-[#F5F5F5] !text-black border !border-[#D9D9D9]"
                    : "bg-black text-white !border-black border"
                    }`}
                disabled={formInputs.email === "" && formInputs.password === ""}
                onClick={handleSubmit}
                type="submit"
            >
                {loader ? "wait..." : formType === "signup" ? "Sign Up" : "Sign In"}
            </button>
        </div >
    );
};

export default AuthForm;
